<template>
  <div>
    <loader :loader="sending" />

    <div class="wrapper-content">
      <encabezado v-if="encabezado" :elementos="encabezado" :action="action" />
      <v-card class="border-card-gray">
        <v-card-text>
          <div name="table" v-if="showAction(1) && table" class="mt-2 ml-4 mr-4">
            <v-row class="pb-2">
              <v-col>
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line dense
                  hide-details></v-text-field>
              </v-col>
              <v-col cols="2" md="2" sm="12" lg="2" class="d-flex justify-center  " v-if="!hideButtonAdd">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="primary" @click="changeAction(2)" v-bind="attrs" v-on="on" block>
                      <v-icon left>{{ addButtonIcon }}</v-icon>
                      {{ addButtonText }}
                    </v-btn>
                  </template>
                  <span>{{ addButtonText }}</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <component key="table" :get="get" :deleteItem="deleteItem" :listAllPagination="listAllPagination"
              :idBranchOffice="idBranchOfficeSelected" :list="list" :is="table" :search="search"
              :currentPage="currentPage" :totalCount="totalCount" :update="update" :model="model" />
            <v-row dense>
              <v-col cols="8" md="8" sm="8" offset="2" class="text-center">
                <paginatesx :click-handler="changePage" :page-count="pageCount" :page-range="1" :margin-pages="1"
                  :prev-text="'<'" :next-text="'>'" :container-class="'pagination'" :page-class="'page-item'">
                </paginatesx>
              </v-col>
              <v-col cols="2" md="2" sm="2" class="text-center mt-5">
                <v-banner outlined single-line>
                  Total: {{ totalCount }}</v-banner>
              </v-col>
            </v-row>
          </div>

          <div name="form" v-if="(showAction(2) || showAction(3)) && form">
            <validation-observer ref="observer" v-slot="{ invalid }">
              <v-form @submit.prevent="undefined" class="mt-8 ml-8 mr-8">
                <component :is="form" key="form" :model="model" />
                <div class="separator20-50">
                  <!-- <v-divider></v-divider> -->
                </div>
                <div class="text-center justify-center">
                  <v-col class=" justify-space-around">
                    <v-menu offset-x bottom left :close-on-content-click="true" rounded="lg">
                      <template v-slot:activator="{ on: menu, attrs }">
                        <v-btn type="button" class="mr-12 mb-4" :disabled="sending" outlined color="error" depressed
                          v-bind="attrs" v-on="{ ...menu }" @click="confirmationReturn()">
                          <v-icon left> mdi-close </v-icon>
                          Cancelar
                        </v-btn>
                      </template>
                    </v-menu>
                    <v-menu offset-x bottom rigth :close-on-content-click="true" rounded="lg">
                      <template v-slot:activator="{ on: menu, attrs }">
                        <v-btn type="button" class="mb-4" :disabled="invalid" v-bind="attrs" depressed v-on="{ ...menu }"
                          color="primary" @click="confirmationSave()">
                          {{ saveButtonText }}
                          <v-icon right>mdi-content-save</v-icon>
                        </v-btn>
                      </template>
                    </v-menu>
                  </v-col>
                </div>
              </v-form>
            </validation-observer>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>
<script>
import Encabezado from "@/app/components/base/header/Header.vue";
import Loader from "@/app/components/base/loader/Loader.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapActions, mapState } from "vuex";
import BranchOfficesList from "@/components/BranchOfficesList.vue";

export default {
  name: "CrudView",
  components: {
    Loader,
    Encabezado,
    ValidationObserver,
    ValidationProvider,
    BranchOfficesList,
  },
  data() {
    return {
      idBranchOffice: null,
      sending: false,
      index: -1,
      action: 1,
      list: [],
      model: {},
      encabezado: null,
      table: null,
      service: null,
      form: null,
      search: "",
      totalCount: 0,
      currentPage: 1,
      itemsPerPage: 10,
      searchDelay: null,
      pageCount: 1,
      hideButtonAdd: false,
      saveButtonText: "",
      addButtonText: "",
      addButtonIcon: "",
      idBranchOfficeSelected: null,
    };
  },
  watch: {
    search(newValue, oldValue) {
      this.deleteSearchDelay();
      this.searchDelay = setTimeout(() => {
        this.currentPage = 1;
        this.listAllPagination();
      }, 400);
    },

    idBranchOfficeState() {
      this.listAllPagination();
    },
  },

  async mounted() {
    this.service = (await this.$route.meta.service()).default || null;
    this.table = (await this.$route.meta.table()).default;
    this.form = (await this.$route.meta.form()).default;
    this.encabezado = this.$route.meta.header;
    this.hideButtonAdd = this.$route.meta.hideButtonAdd || false;
    this.saveButtonText = this.$route.meta.saveButtonText || "guardar";
    this.addButtonText = this.$route.meta.addButtonText || "Agregar";
    this.addButtonIcon = this.$route.meta.addButtonIcon || "mdi-plus";

    
    if(this.$utilFront.nonEmpty( this.$route.meta.prmAdd) && this.hideButtonAdd === false){
      this.hideButtonAdd = !this.$utilFront.withPermission(this.$route.meta.prmAdd) 
    }

    this.listAllPagination();
  },
  computed: {
    ...mapState(["idBranchOfficeState"]),
  },
  methods: {
    // ...mapActions(["updateBranchOffice", "updateAction"]),
    confirmationReturn() {
      this.swalDialog = true;
      this.$swal({
        toast: true,
        title: "¿Desea regresar a la vista principal?",
        text: "",
        icon: "warning",
        confirmButtonText: "Confirmar",
        showCancelButton: true,
        cancelButtonText: "No",
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      }).then((result) => {
        if (result.value) {
          this.swalDialog = false;
          this.changeAction(1);
        } else {
          this.swalDialog = false;
        }
      });
    },
    confirmationSave() {
      this.swalDialog = true;
      this.$swal({
        toast: true,
        title: "¿Desea guardar el registro actual?",
        // html: "¿Desea <b>guardar</b> el registro actual? ",
        text: "",
        icon: "warning",
        confirmButtonText: "Confirmar",
        showCancelButton: true,
        cancelButtonText: "No",
        reverseButtons: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      }).then((result) => {
        if (result.value) {
          this.swalDialog = false;
          this.doAction();
        } else {
          this.swalDialog = false;
        }
      });
    },
    branchOfficeSelected(selected) {
      this.idBranchOfficeSelected = selected;
      this.listAllPagination();
    },
    showAction(action) {
      return this.action == action;
    },
    changeAction(action) {
      if (action == 1) {
        this.model = {};
        this.action = action;
      } else {
        this.action = action;
      }
    },
    doAction() {
      switch (this.action) {
        case 2:
          this.add();
          break;
        case 3:
          this.update();
          break;
        default:
          break;
      }
    },
    changePage(page) {
      if (this.currentPage != page) {
        this.currentPage = page;
        this.listAllPagination();
      }
    },
    deleteSearchDelay() {
      if (this.searchDelay != null) {
        clearTimeout(this.searchDelay);
        this.searchDelay = null;
      }
    },
    listAllPagination() {
      this.sending = true;
      let params = {
        search: this.search,
        maxResults: this.itemsPerPage,
        page: this.currentPage,

        idBranchOffice:
          this.idBranchOfficeSelected != null
            ? this.idBranchOfficeSelected
            : this.$utilFront.getIdBranchOffice(),
      };
      this.service
        .listAllPagination(params)
        .then((res) => {
          this.sending = false;
          let { list, count } = res.data;
          this.list = list;
          this.totalCount = count;
          this.pageCount = Math.ceil(count / this.itemsPerPage);
        })
        .catch((e) => {
          this.sending = false;
          this.$utilFront.errorhttp(e);
        });
    },
    add() {
      if (!this.sending) {
        this.sending = true;
        this.service
          .add(this.model)
          .then((response) => {
            this.sending = false;
            let { data, status } = response;
            if (status == 200) {
              this.listAllPagination();
              this.$utilFront.notifications(
                "Se ha agregado correctamente.",
                "SUCCESS"
              );
              this.changeAction(1);
            } else {
              data = data || "Ocurrió un error durante el registro.";
              this.$utilFront.notifications(data, "ERROR");
            }
          })
          .catch((e) => {
            this.sending = false;
            this.$utilFront.errorhttp(e);
          });
      }
    },
    update() {
      if (!this.sending) {
        this.sending = true;
        this.service
          .update(this.model)
          .then((response) => {
            this.sending = false;
            let { data, status } = response;
            if (status == 200) {
              this.listAllPagination();
              this.$utilFront.notifications(
                "Se ha modificado correctamente.",
                "SUCCESS"
              );
              this.changeAction(1);
            } else {
              data = data || "Ocurrió un error durante la modificación.";
              this.$utilFront.notifications(data, "ERROR");
            }
          })
          .catch((e) => {
            this.sending = false;
            this.$utilFront.errorhttp(e);
          });
      }
    },
    get(params, i) {
      if (!this.sending) {
        this.sending = true;
        this.service
          .get(params)
          .then((response) => {
            this.sending = false;
            let { data, status } = response;
            if (status == 200) {
              this.model = data;
              this.changeAction(i);
            } else {
              data = data || "Ocurrió un error al obtener la información.";
              this.$utilFront.notifications(data, "ERROR");
            }
          })
          .catch((e) => {
            this.sending = false;
            this.$utilFront.errorhttp(e);
          });
      }
    },
    deleteItem(params, i) {
      if (!this.sending) {
        this.sending = true;
        this.service
          .delete(params)
          .then((response) => {
            this.sending = false;
            let { data, status } = response;
            if (status == 200) {
              this.list.splice(i, 1);
              this.totalCount--;
              if (this.totalCount >= this.itemsPerPage) {
                this.listAllPagination();
              }
              this.listAllPagination();
              this.$utilFront.notifications(
                "Se ha eliminado correctamente.",
                "SUCCESS"
              );
            } else {
              data = data || "Ocurrió un error al eliminar la información.";
              this.$utilFront.notifications(data, "ERROR");
            }
          })
          .catch((e) => {
            this.sending = false;
            this.$utilFront.errorhttp(e);
          });
      }
    },
  },
};
</script>
